module.exports = __webpack_public_path__ + "static/media/girl-hover.c8fd99e1.png";